var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Logo"},[_c('ui-image',{attrs:{"alt":_vm.$t('common.logo'),"src":_vm.logoUrl,"width":_vm.LOGO_SIZE.width,"height":_vm.LOGO_SIZE.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }